import { useMemo } from 'react';
import { qrcodegen } from '@utils/qrcodegen';

interface AppQrCodeProps {
  value: string;
  size?: number;
  className?: string;
}

const AppQrCode = ({ value, size = 200, className }: AppQrCodeProps) => {
  const { gridSize, cells } = useMemo(() => {
    const qrCode = qrcodegen.QrCode.encodeText(value, qrcodegen.QrCode.Ecc.HIGH);
    const dimension = qrCode.size;
    const matrix: boolean[][] = [];

    for (let rowIndex = 0; rowIndex < dimension; rowIndex += 1) {
      matrix.push([]);
      for (let columnIndex = 0; columnIndex < dimension; columnIndex += 1) {
        matrix[rowIndex].push(qrCode.getModule(columnIndex, rowIndex));
      }
    }

    return { gridSize: dimension, cells: matrix };
  }, [value]);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${gridSize} ${gridSize}`}
      className={className}
      role="img"
      aria-label="Mobil uygulama indirme QR kodu"
    >
      <rect width={gridSize} height={gridSize} fill="#FFFFFF" />
      {cells.map((row, rowIndex) =>
        row.map(
          (isDark, columnIndex) =>
            isDark && (
              <rect
                key={`${columnIndex}-${rowIndex}`}
                x={columnIndex}
                y={rowIndex}
                width={1}
                height={1}
                fill="#000000"
              />
            ),
        ),
      )}
    </svg>
  );
};

export default AppQrCode;
